export const sliderItems = [
    {
      id: 1,
      img: "https://as2.ftcdn.net/v2/jpg/04/33/03/09/1000_F_433030969_MsxRzfHjUC6RB4vyUsqtcUvXZL6sM7xY.jpg",
      title: "打造自己的專屬網頁",
      desc: "提供虛擬主機，網域連結，響應式網頁（手機版設計），SEO優化，會員管理，使用者統計，行銷工具。品牌官網，個人網站，部落格經營需要的工具都在SamKo電商平台內。專人為你隨時服務",
      bg: "f5fafd",
    },
    {
      id: 2,
      img: "https://as2.ftcdn.net/v2/jpg/04/45/54/21/1000_F_445542149_dOMYc1ABkVVSOz9VgZJEVscjf3vGwceH.jpg",
      title: "秋冬時尚",
      desc: "指定單品、UT、秋冬設計師聯名，期間限定SALE 5折起，今天就把喜歡的商品都帶回家！ 在地萬歲節，新生活更有生命力，最低優惠99起，再享多重台灣限定滿額送好禮",
      bg: "fcf1ed",
    },
    {
      id: 3,
      img: "https://i.ibb.co/cXFnLLV/3.png",
      title: "夏日特賣",
      desc: "最新聯名系列將於今年夏日再度登場。 最強設計師共同打造的合作系列，流行服飾女裝男裝單品上架中。",
      bg: "ebb4c8",
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      title: "商品類別一衣服類",
      cat:"時尚服飾"
    },
    {
      id: 2,
      img: "https://as2.ftcdn.net/v2/jpg/03/13/81/39/1000_F_313813981_j5rYT70dXfJAcGYqj5mEL59TBvrEbGKB.jpg",
      title: "商品類別二寵物類",
      cat:"寵物類"
    },
    {
      id: 3,
      img: "https://as2.ftcdn.net/v2/jpg/02/26/77/35/1000_F_226773530_BrvUb4vCFiFvx7smjRviqlAEOO2RHFoI.jpg",
      title: "商品類別三食物類",
      cat:"食物類"
    },
  ];

  export const popularProducts = [
    {
      id:1,
      img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    },
    {
      id:2,
      img:"https://cdn.shopify.com/s/files/1/0101/4832/products/Angela_Natural_Tee.png?v=1606780388",
    },
    {
      id:3,
      img:"https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    },
    {
      id:4,
      img:"https://www.burdastyle.com/pub/media/catalog/product/cache/7bd3727382ce0a860b68816435d76e26/107/BUS-PAT-BURTE-1320516/1170x1470_BS_2016_05_132_front.png",
    },
    {
      id:5,
      img:"https://tshop.r10s.com/88b/307/0d67/e9db/f084/271c/3b4d/1166ecabdf0242ac110003.jpg",
    },
    {
      id:6,
      img:"https://tshop.r10s.com/5db/042/adf1/e41d/e086/0de5/ff8f/11adebb00a0242ac110005.png",
    },
    {
      id:7,
      img:"https://tshop.r10s.com/484/33e/96c7/e3fa/1087/960c/55cc/1109eaadc20242ac110005.jpg",
    },
    {
      id:8,
      img:"https://shop.r10s.com/784/61a/932a/7156/a0e9/2ccc/954a/111aec9a9a0242ac110002.jpg",
    },
  ]